import React from 'react';
import Typography from '@material-ui/core/Typography';
import { IKeyValue } from '../../../appConstants';

interface IScoutingReportAverageRowProps {
    rowData : Record<string, number>;
    headers : IKeyValue<Array<string>>;
}

interface IScoutingReportAverageRowState {}

export default class ScoutingReportAverageRow extends React.PureComponent<IScoutingReportAverageRowProps, IScoutingReportAverageRowState> {
    constructor(props : IScoutingReportAverageRowProps) {
        super(props);
        this.state = {};
    }

    public render = () => {
        const { rowData } = this.props;
        return (
            <div className='fdr mnh32 bocg5 bnl bcp'>
                <div className='fdr mnw180 mxw180 aic'>
                    <Typography className='fwb fs12-16 flx1 cw pl24'>Average Count</Typography>
                </div>
                {
                    Object.keys(this.props.headers).map(header => (
                        <div className='flx1 fwb fs13-18 lsp02 cw tac brw1 bocg4 bnl' key={`value_totals_${header}`}>
                            <div className='flx1 aic jcc bocg3 brw1'>
                                {
                                    rowData[header].toFixed(2)
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }
}
